import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocumentsVersionsData } from '../requests';

export const useGetDocumentsVersionsData = (
  documentId?: number,
  versionId?: number | undefined,
) =>
  useQuery({
    queryKey: [
      API_QUERY_KEYS.documentsVersionsData,
      { documentId: documentId!, versionId: versionId! },
    ],
    queryFn: () =>
      getDocumentsVersionsData({
        documentId: documentId!,
        versionId: versionId!,
      }),
    enabled: !!documentId && !!versionId,
  });
